var isDevelopment="undefined"!=typeof process&&process.env&&(!process.env.NODE_ENV||"development"===process.env.NODE_ENV);export default isDevelopment;